export const isValidEmail = (email) => /(.+)@(.+){2,}\.(.+){2,}/.test(email);

export const PASSWORD_CONDITIONS = {
  length: { condition: /(.+){10,}/, message: '10 characters or more' },
  digits: { condition: /\d/, message: 'a number' },
  uppercase: { condition: /[A-Z]/, message: 'an uppercase letter' },
  lowercase: { condition: /[/a-z/]/, message: 'a lowercase letter' },
  symbols: {
    condition: /[ !#$%&'()*+,-./[\]^_`{|}~]/,
    message: 'a special character',
  },
};

export const isValidPassword = (password) =>
  Object.keys(PASSWORD_CONDITIONS).every((conditionKey) =>
    PASSWORD_CONDITIONS[conditionKey].condition.test(password),
  );
